import { render, staticRenderFns } from "./UpdateCoordinator.vue?vue&type=template&id=866547ae&"
import script from "./UpdateCoordinator.vue?vue&type=script&lang=js&"
export * from "./UpdateCoordinator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports